import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonVariant, IconName, POPOVER_ANIMATION_DURATION, Popover, PopoverType, usePopoverHandlers, } from '@as/cotopaxi';
import { EventEnum } from '@as-react/common-types';
import { EventUtil } from '@as-react/common-utils';
import { Box } from '@yonderland/andes-react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
export const SizeGuideV2 = ({ isPopup, onClick, sizeGuideContent, sizeGuideContentUrl, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const [isOpen, setIsOpen] = useState(false);
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers({
        close: () => setIsOpen(false),
    });
    const handleSizeGuideOpen = () => {
        onClick();
        if (isPopup) {
            setIsOpen(true);
        }
        else {
            window.open(sizeGuideContentUrl, '_blank');
        }
    };
    useEffect(() => {
        if (isOpen) {
            handlePopoverOpen(null, null, true);
            setTimeout(() => EventUtil.dispatch(EventEnum.SIZE_GUIDE_POPOVER_OPEN), POPOVER_ANIMATION_DURATION);
        }
    }, [isOpen]);
    return (_jsxs(Box, { paddingBlockStart: { base: '2', md: '0' }, children: [_jsx(Button, { dataQA: "size_guide", iconLeft: { name: IconName.DIAGONAL_RULER }, onClick: handleSizeGuideOpen, text: t('product.size.guide.link'), variant: ButtonVariant.LINK }), isPopup && (_jsx(Popover, { anchorEl: anchorEl, type: PopoverType.MODAL, onClose: handlePopoverClose, title: t('product.size.guide.link'), dataQA: "size_guide_popup", children: _jsx(HtmlInclude, { htmlFragment: sizeGuideContent }) }))] }));
};
